











import { Component, Mixins, Prop } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../../base/components/system/mixins";
import { OptionDropDownSelector } from "../../../../../base/components/system/selectors";
import { StandardOption } from "../../../../../base/components/system/selectors/mixins";
import { IDesignatedDoctorInformationSource } from "../../../../domain/format/objects";

@Component({
  components: {
    OptionDropDownSelector,
  }
})

export default class DesignatedDoctorInformationSourceEditor extends Mixins(ModelEditableMixin) {
  writePropertyWhenValid: (writer: (source: IDesignatedDoctorInformationSource) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IDesignatedDoctorInformationSource) => T, defaultValue: T) => T;

  @Prop()
  typeOptions: StandardOption<string>[];

  get type(): string {
    return this.readPropertyOrDefault(s => s.type, (!!this.typeOptions && (0 < this.typeOptions.length)) ? this.typeOptions[0].label : "");
  }

  set type(value: string) {
    this.writePropertyWhenValid(s => s.type = value);
  }
}
